"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class AccountService {
    constructor(client) {
        this._client = client;
    }
    /**
     * @see https://api-reference.kevin.eu/public/platform/v0.3#operation/getAccounts
     */
    getAccounts(options) {
        return this._client.sendRequest(AccountService.ROUTES.LIST, 'get', { headers: options.headers, bearerToken: options.token });
    }
    /**
     * @see https://api-reference.kevin.eu/public/platform/v0.3#operation/getAccount
     */
    getAccount(options) {
        return this._client.sendRequest(AccountService.ROUTES.DETAILS, 'get', { headers: options.headers, bearerToken: options.token, pathParameters: { accountId: options.accountId } });
    }
    /**
     * @see https://api-reference.kevin.eu/public/platform/v0.3#operation/getAccountTransactions
     */
    getAccountTransactions(options) {
        return this._client.sendRequest(AccountService.ROUTES.TRANSACTIONS, 'get', {
            headers: options.headers,
            bearerToken: options.token,
            pathParameters: { accountId: options.accountId },
            queryParameters: { dateFrom: options.dateFrom, dateTo: options.dateTo },
        });
    }
    /**
     * @see https://api-reference.kevin.eu/public/platform/v0.3#operation/getAccountBalance
     */
    getAccountBalance(options) {
        return this._client.sendRequest(AccountService.ROUTES.BALANCE, 'get', { headers: options.headers, bearerToken: options.token, pathParameters: { accountId: options.accountId } });
    }
}
AccountService.ROUTES = {
    LIST: '/ais/accounts',
    DETAILS: '/ais/accounts/{accountId}',
    TRANSACTIONS: '/ais/accounts/{accountId}/transactions',
    BALANCE: '/ais/accounts/{accountId}/balance',
};
exports.default = AccountService;
